import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';

// <Dev.Note.Security>
//  The principle we follow here is that in order to make your app more secure
//  try to think before you are using a 3rd party library and validate if you really need it.
//  If the answer is yes it is better to wrap your 3rd party apis. For example we have a
//  wrapper around axios that provides you a HttpClient
//
//  You don't need to wrap the entire react :) or redux but it make sense for use to wrap a Logger
//  library or a HttpClient library.
// </Dev.Note.Security>

export const instanceOptions: Partial<AxiosRequestConfig> = {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(process.env.NODE_ENV !== 'development' && { 'X-Requested-With': 'XMLHttpRequest' }),
    },
    withCredentials: true,
    paramsSerializer: (queryParams) => qs.stringify(queryParams, { arrayFormat: 'comma' }),
};

// Set up a custom bff instance
export const bffClient = axios.create({
    ...instanceOptions,
    baseURL: `${process.env.REACT_APP_COBRA_URL}/bff`,
});

// Auth client
export const authClient = axios.create({
    ...instanceOptions,
    baseURL: process.env.REACT_APP_COBRA_URL,
});

export const httpClient = axios.create({
    ...instanceOptions,
    baseURL: process.env.REACT_APP_API_URL,
});
